export const hasAccessCheck = (requiredAccess: string): boolean => {
    const definedAccess = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined;
    if (!definedAccess) return false;
  
    const parsedAccess = JSON.parse(definedAccess);
    const access = parsedAccess?.access || [];
  
    const filteredAccess = access.filter(
      (item: any) =>
        item.module_name?.toLowerCase() === requiredAccess.toLowerCase()
    );
  
    return filteredAccess?.[0]?.read_access || false;
  };
  